// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e4184886","636":"28cee24b"}[chunkId] + ".chunk.js";
};